import { ClientView, ClientViewSchema } from "@common/types/views/clientViews";
import { omit } from "@common/helpers/objects";
import { useDefaultClientView } from "@components/organizationView/clients/views/DefaultClientView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

const viewSanitizer = (view?: ClientView) => {
    if (!view) {
        return undefined;
    }

    return { ...view, filters: omit(view.filters, ["search"]) };
};

interface UseClientViewStoreOptions {
    defaultView?: ClientView;
    parentFilters?: ClientView["filters"];
    cacheKey?: ORGANIZATION_USER_CACHE_KEYS;
}

export function useClientViewStore({
    defaultView,
    parentFilters,
    cacheKey,
}: UseClientViewStoreOptions = {}) {
    const defaultClientView = useDefaultClientView();

    return useViewStore<ClientView>({
        defaultView: defaultView ?? defaultClientView,
        viewSchema: ClientViewSchema,
        parentFilters,
        cacheKey,
        viewSanitizer,
    });
}
